import React, { useContext, useState } from 'react';
import Ok from '../Dialog/Ok';
import { store as mainStore } from '../../store';
import TextField from '@material-ui/core/TextField';
import { useMainStore } from 'useStores/useMainStore';

const SettingDialog = ({ onClose, open }) => {
  const {
    state: {
      Props: { itemsCountPerPage },
    },
    dispatch,
  } = useContext(mainStore);
  const [itemsCount, setItemsCount] = useState(itemsCountPerPage);
  const setLimit = useMainStore((state) => state.setLimit);

  const submitItemsCount = () => {
    dispatch({
      type: 'PROPS',
      action: 'ITEMS_COUNT_PER_PAGE',
      payload: { itemsCountPerPage: itemsCount },
    });
    setLimit(itemsCount);
    onClose();
  };

  return (
    <form>
      <Ok
        open={open}
        title="تنظیمات پنل"
        ok="تغییر"
        onClose={submitItemsCount}
        fullWidth={false}
      >
        <TextField
          name="itemsCountPerPage"
          label="تعداد آیتم‌های لیست‌ها"
          fullWidth
          variant="outlined"
          type="number"
          onChange={(e) => setItemsCount(e.target.value)}
          value={itemsCount}
          defaultValue={50}
        />
      </Ok>
    </form>
  );
};

export default React.memo(SettingDialog);
